import { Button } from "@material-ui/core";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import { useBackAction } from "../../shared/util/useBackAction";

export function BackAction() {
  const goBack = useBackAction();

  return (
    <Button
      onClick={() => {
        goBack();
      }}
      startIcon={<ChevronLeft />}
    >
      Back
    </Button>
  );
}

export default BackAction;
